import { FC } from 'react'

import { Menu } from './menu'
import { StyledMask, StyledSider } from './styled'

interface SiderProps {
  collapsed: boolean
  onCollapse: (collapsed: boolean) => void
}

export const Sider: FC<SiderProps> = ({ collapsed, onCollapse }) => {
  return (
    <>
      <StyledSider
        breakpoint="lg"
        width={320}
        collapsedWidth="0"
        onCollapse={onCollapse}
        collapsed={collapsed}
        trigger={null}
      >
        <Menu />
      </StyledSider>
      {!collapsed && <StyledMask onClick={() => onCollapse(true)} />}
    </>
  )
}
